<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fZeKUo/tc-custom/9781528989305.jpg?1705540911184" alt="This image is the cover for the book Shit Happens!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shit Happens!
      </h1>
      <p class="bookDescription body article font2">
        <p>The contents of this book are a perfectly true account of the noteworthy events that occurred before and during the author’s 53-year career in sewage treatment and water pollution control. Many of those events, referred to as “SHIT HAPPENINGS” were extremely amusing and some were absolutely hilarious, though in some cases they were undoubtedly dangerous to the author himself as well as others. Many of those occurrences were almost unbelievable but even after many years they remain etched into people’s memories. Some events could be regarded as ‘tragi-comic’; amusing for some people but causing misery, discomfort and despair as well for others. Some were indeed extremely tragic, where innocent lives were lost and most of these were caused by a combination of laziness, greed and lack of concern for others. These last three qualities were clearly shown in all the countries the author worked in: The United Kingdom (England, Scotland and Wales), Thailand, Hong Kong, Egypt, Turkey, Singapore, Taiwan, and Australia. However, it must be said that SHIT did not HAPPEN in all of them.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David W Marpole
      </h2>
      
      <p class="authorDescription body article">When David W Marpole left school, he wanted to be a chemist but he had to start work at 16 and was unable to go to university to study. His best opportunity was to work as a junior assistant chemist at a large sewage treatment works where his employers expected and encouraged him to study part time. As a qualified professional, he subsequently made his career in water pollution control, largely in the field of wastewater management, working in UK plus seven foreign countries where he encountered many different attitudes to water pollution control.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1b310730